import { LinkProps } from "@tanstack/react-router";

export type TopNavItem = {
  title: string;
  href: LinkProps["to"];
  isActive: boolean;
  disabled: boolean;
};

export const TOP_NAV: TopNavItem[] = [
  {
    title: "Organization Details",
    href: "/root-user/organization/organization/$id/detail",
    isActive: true,
    disabled: false,
  },
  {
    title: "Update Organization",
    href: "/root-user/organization/organization/$id/update",
    isActive: false,
    disabled: false,
  },
];
